import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class DepotsMultiSelectCtrl implements IController {

  selectedIds: any;
  options: any;
  optionIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  onChange: Function;

  private depotsRef: any;
  public selectedDepots: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $depots, private $element) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    this._setSelectedDepots();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedDepots();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'depots';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({depots: [], selectedIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const depots = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({depots: depots, selectedIds: selectedIds});
            panel.destroy();
          } else {
            this.depotsRef.$asyncValues(selectedIds)
              .then((depots: any[]) => {
                this.onChange({depots: depots, selectedIds: selectedIds});
                panel.destroy();
              });
          }
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  private _setSelectedDepots() {
    if (!!this.selectedIds) {
      if (!!this.options) {
        this.selectedDepots = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.depotsRef.$asyncValues(this.selectedIds)
          .then((depots) => {
            this.selectedDepots = _.orderBy(depots, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedDepots = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedDepots, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedDepots.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedDepots[0].name + ` +${this.selectedDepots.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotsMultiSelect', {
    bindings: {
      selectedIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./depots-multi-select.html').default,
    controller: DepotsMultiSelectCtrl
  });
